import * as React from 'react';
import * as reg from "./style.module.scss";
export const Reg = ({ widget }) => {
  return (
    <section className={reg.reg}>
      <div className="container">
        <div className={reg.inner}>
          <div className={reg.desc}>

            <p>Десятки тысяч человек уже освоили английский по нашим технологиям для сдачи ЕГЭ, преподавания, карьерного роста, командировок, знакомств, путешествий и общения.
            </p>
            <p>И у вас точно получится!</p>

            <p className={reg.undertext}>
              РЕГИСТРИРУЙТЕСЬ БЕСПЛАТНО И ПОПРОБУЙТЕ
            </p>
          </div>
          <div className={reg.widget} id={"widget"}>
            { widget }
          </div>
        </div>
      </div>
    </section>
  );
};
